// Format a date value (ISO string, e.g. the backend's IST `createdAt`
// "2026-06-15T13:08:30.000+05:30", or a raw UTC `created_at`) for display in
// India Standard Time. Forcing timeZone Asia/Kolkata makes it read in IST
// regardless of the admin's browser timezone. Returns "—" for missing/invalid.
export const formatDateTime = (value) => {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return new Intl.DateTimeFormat('en-IN', {
    day: '2-digit', month: 'short', year: 'numeric',
    hour: '2-digit', minute: '2-digit', hour12: true,
    timeZone: 'Asia/Kolkata',
  }).format(d);
};

// Date only (no time), e.g. "15 Jun 2026".
export const formatDate = (value) => {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return new Intl.DateTimeFormat('en-IN', {
    day: '2-digit', month: 'short', year: 'numeric', timeZone: 'Asia/Kolkata',
  }).format(d);
};

export default formatDateTime;
